<div *ngIf="!device.isTablet">
    <div class="sk-betslip-header-container">
        <div class="sk-betslip-circle"></div>
        <div class="sk-betslip-info">
            <div class="sk-betslip-info1 sk-h-12 sk-b-rad8"></div>
            <div class="sk-betslip-info2 sk-h-12 sk-b-rad8"></div>
        </div>
    </div>

    <div class="sk-betslip-imgage-container">
        <div class="sk-betslip-image-card"></div>

        <div class="sk-betslip-stake sk-p-12">
            <div class="sk-betslip-stake-info sk-h-12 sk-b-rad8"></div>

            <div class="sk-betslip-stake-container">
                <div class="sk-stake-circle"></div>
                <div class="sk-stake-info">
                    <div class="sk-stake-info1 sk-h-12 sk-b-rad8"></div>
                    <div class="sk-stake-info2 sk-h-12 sk-b-rad8"></div>
                </div>
            </div>

            <div class="sk-betslipscore sk-h-12 sk-b-rad8"></div>
            <div class="sk-betslipscore1 sk-h-12 sk-b-rad8" *ngFor="let in of [0, 1]"></div>
        </div>
    </div>
</div>
